import { useParams } from 'react-router-dom'

import {
  BRAND_KIT_ID_PARAM_KEY,
  DB_ID_PARAM_KEY,
  ORG_ID_PARAM_KEY,
  PROJECT_ID_PARAM_KEY,
  TBL_ID_PARAM_KEY,
  TEAM_ID_PARAM_KEY,
} from '@/shared/constants'

export type ParamId = 'org' | 'team' | 'project' | 'db' | 'tbl' | 'brand'

/**
 * A hook for getting the ID of an object from the URL parameters.
 *
 * @param id - The type of object ID to get. One of `ParamId`
 * @returns The ID of the object.
 */
export function useParamId(id: ParamId) {
  const params = useParams()
  let ty = ORG_ID_PARAM_KEY

  switch (id) {
    case 'project':
      ty = PROJECT_ID_PARAM_KEY
      break
    case 'team':
      ty = TEAM_ID_PARAM_KEY
      break
    case 'db':
      ty = DB_ID_PARAM_KEY
      break
    case 'tbl':
      ty = TBL_ID_PARAM_KEY
      break
    case 'brand':
      ty = BRAND_KIT_ID_PARAM_KEY
      break
    case 'org':
      ty = ORG_ID_PARAM_KEY
      break
  }

  return params[ty]
}
